export const COMPETE_EVAL_URL_BASE = '/compete-answer-comparison';
